module.exports = __webpack_public_path__ + "img/mockup_bus@2x.e7bbb4d6.png";